import { ThemeProvider } from '@fattureincloud/fic-design-system';
import React, { Component } from 'react';
import { Router } from './router';
import { register, unregister } from './serviceWorker';
import { theme } from './palette';
import { enableProductionServices, isProductionVersion } from 'utils/route';
import { initializeGTM } from 'googleTagManager';
import packageJson from '../package.json';

type State = {};

type ServiceWorkerEvent = Event & { target: (Partial<ServiceWorker> & EventTarget) | null };

// this class manage the service worker
export class App extends Component<{}, State> {
  private enableProductionServices: boolean;
  constructor(props: {}) {
    super(props);
    this.state = {};
    this.enableProductionServices = enableProductionServices();
  }

  private preventDefault = (event: Event) => {
    event.preventDefault();
    return null;
  };

  private removeNoIndex = () => {
    const metaTag = document.querySelector(`meta[name="robots"]`);
    metaTag && metaTag.remove();
  };

  componentDidMount() {
    console.info('App version:', `${process.env.NODE_ENV} ${packageJson.version}`);
    initializeGTM();
    // Remove index on production
    isProductionVersion() && this.removeNoIndex();
    if (this.enableProductionServices) {
      window.addEventListener('beforeinstallprompt', this.preventDefault);
      register({ onUpdate: this.onServiceWorkerUpdate });
      this.keepWatchingSW();
    } else {
      unregister();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeinstallprompt', this.preventDefault);
  }

  // every hour check for a new app version
  private keepWatchingSW = () => {
    window.setInterval(() => {
      navigator?.serviceWorker?.getRegistrations().then((registrationsArray) => registrationsArray[0].update());
    }, 1000 * 60 * 60);
  };

  private onServiceWorkerUpdate = (registration: ServiceWorkerRegistration) => {
    const waitingServiceWorker = registration?.waiting;

    // Apply update immediately without showing modal
    waitingServiceWorker?.addEventListener('statechange', (event: ServiceWorkerEvent) => {
      if (event?.target?.state === 'activated') {
        window.location.reload();
      }
    });

    // Trigger the update immediately
    waitingServiceWorker?.postMessage({ type: 'SKIP_WAITING' });
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router />
      </ThemeProvider>
    );
  }
}
